<template>
  <CBox class="biometry-intro">
    <CBox class="biometry-intro__backdrop" />

    <CBox
      class="biometry-intro__sheet"
      role="dialog"
      aria-modal="true"
    >
      <button
        type="button"
        class="biometry-intro__close"
        aria-label="Fechar"
        @click="$emit('close')"
      />

      <CBox class="biometry-intro__content">
        <OmtTypography
          as="h1-bold"
          class="biometry-intro__title"
        >
          Para a sua segurança precisamos confirmar a sua identidade
        </OmtTypography>

        <OmtTypography
          as="h3-semi-bold"
          class="biometry-intro__description"
        >
          Prepare-se para o reconhecimento facial posicionando o seu rosto no espaço abaixo, e siga as instruções para
          captura da sua imagem.
        </OmtTypography>

        <CBox
          class="biometry-intro__portrait"
          aria-hidden="true"
        />
      </CBox>

      <CBox class="biometry-intro__action">
        <slot name="action">
          <OmtButton
            width="100%"
            height="58px"
            @click="$emit('start')"
          >
            {{ buttonLabel }}
          </OmtButton>
        </slot>
      </CBox>
    </CBox>
  </CBox>
</template>

<script>
export default {
  name: "BiometryIntroSheet",
  props: {
    buttonLabel: {
      type: String,
      default: "Começar"
    }
  }
};
</script>

<style scoped>
.biometry-intro {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.biometry-intro__backdrop {
  position: absolute;
  inset: 0;
  background: #000000;
  opacity: 0.3;
}

.biometry-intro__sheet {
  position: relative;
  display: flex;
  flex-direction: column;
  width: min(100vw, 375px);
  height: calc(100vh - 12px);
  padding: 28px 16px 26px;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  max-height: calc(100vh - 12px);
  overflow: hidden;
}

.biometry-intro__close {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
}

.biometry-intro__close::before,
.biometry-intro__close::after {
  position: absolute;
  top: 15px;
  left: 4px;
  width: 26px;
  height: 2px;
  content: "";
  background: #4e4e4e;
  border-radius: 2px;
}

.biometry-intro__close::before {
  transform: rotate(45deg);
}

.biometry-intro__close::after {
  transform: rotate(-45deg);
}

.biometry-intro__content {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  padding-top: 36px;
}

.biometry-intro__title {
  width: 339px;
  max-width: 100%;
  margin-bottom: 0;
  color: #4e4e4e;
  line-height: 32px !important;
}

.biometry-intro__description {
  width: 343px;
  max-width: 100%;
  margin-top: 0;
  color: #4e4e4e;
}

.biometry-intro__portrait {
  flex-shrink: 0;
  width: 249px;
  max-width: 66vw;
  height: clamp(354px, calc(100vh - 369px), 587px);
  margin: 40px auto 24px;
  background: #f6f6f9;
  border-radius: 171px;
}

.biometry-intro__action {
  width: 100%;
  margin-top: auto;
}

.biometry-intro__action button {
  font-size: 20px !important;
  font-weight: 700 !important;
  line-height: 24px !important;
}

.biometry-intro__action [data-cy="biometry-camera-button"] {
  width: 100%;
}

@media screen and (min-width: 768px) {
  .biometry-intro {
    align-items: center;
  }

  .biometry-intro__sheet {
    width: 420px;
    height: min(656px, calc(100vh - 24px));
    max-height: calc(100vh - 24px);
    border-radius: 16px;
    box-shadow: 0 24px 64px rgb(0 0 0 / 18%);
  }

  .biometry-intro__portrait {
    height: min(354px, calc(100vh - 330px));
  }
}

@media screen and (max-height: 620px) {
  .biometry-intro__portrait {
    margin-top: 24px;
  }
}
</style>
